import React, { Component } from "react";
import { connect } from "react-redux";

import { signIn } from "../../actions/authActions";
import { RESPONSE_STATUS } from "../../utils/constants";
import * as util from "../../utils/util";
import { answerBubbleStyle, answerBubbleStyleMobile } from "../../utils/styles";
import { QuestionComponent, QuestionComponentButton } from "./OnboardingStyles";
import { utils } from "redux-saga";

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      phoneNumber: "",
      password: "",
      accountExist: false,
      emailInvalid: false,
      phoneInvalid: false,
      submitted: false,
      errorMessage: "",
      accountOptIn: false,
      phoneCountry:'US'
    };
  }

  componentWillMount() {
    if (window.location.pathname.includes("/ath"))
      this.setState({ accountOptIn: true });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isAuthenticated) {
      this.props.triggerNextStep();
    }
  }

  handleChange = e => {
    let output = e.target.value;
    let phoneOutput;
    if (e.target.name === "phoneNumber") {
      let input = output;
      input = input.replace(/[^0-9]/g, "");

      let area = input.substr(0, 3);
      let pre = input.substr(3, 3);
      let last = input.substr(6, 4);

      if(this.state.phoneCountry == 'UK'){
        phoneOutput = output.substr(0, 10);
      }else{
        if (area.length < 3) {
          phoneOutput = "(" + area;
        } else if (area.length === 3 && pre.length < 3) {
          phoneOutput = "(" + area + ") " + pre;
        } else if (area.length === 3 && pre.length === 3) {
          phoneOutput = "(" + area + ") " + pre + "-" + last;
        }
      }
   
      this.setState({ [e.target.name]: phoneOutput });
      return;
    }else if(e.target.name === "phoneCountry"){
      this.setState({
        phoneNumber: ''
      });
    }

    this.setState({ [e.target.name]: output });
  };

  handleEmailInputComplete = () => {
    const email = this.state.email;
    if (email) {
      fetch("/api/account/status?email=" + email)
        .then(response => response.text())
        .then(status => {
          this.setState({
            accountExist: status === "true",
            emailInvalid: false
          });
        });
    }
  };

  handleEmailInputCompleteAth = () => {
    const email = this.state.email;
    const url = "/api/ath/users/exist?email=" + email;
    if (email && email !== "") {
      fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }).then(response => {
        if (response.status >= 400 && response.status < 500)
          this.setState({ accountExist: false, emailInvalid: false });
        else if (response.status >= 200 && response.status < 300)
          this.setState({
            accountExists: true,
            errorMessage: "Account already exists."
          });
      });
    }
  };

  handleKeyPressed(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      this.handleSubmit();
    }
  }

  handleKeyDown(e) {
    let key = e.keyCode;
    if (key === 8) {
      let output = e.target.value;
      if (output.slice(-1) === " ") {
        output = output.substring(0, output.length - 2);
      } else {
        output = output.substring(0, output.length - 1);
      }
      this.setState({ [e.target.name]: output });
    }
  }

  gtag_report_conversion_create_an_account(url) {
    let callback = function() {
      if (typeof url !== "undefined") {
        window.location = url;
      }
    };
    window.gtag("event", "conversion", {
      send_to: "AW-782420739/LOabCPiL74wBEIOWi_UC",
      event_callback: callback
    });
    return false;
  }

  handleSubmit() {
    const { email, password, phoneNumber } = this.state;
    if (this.state.accountExist) {
      if (email && password) {
        this.props.signIn(email, password);
      }
    } else {
      if (email && password && phoneNumber) {
        const isValidEmail = util.isValidEmail(email);
        const isValidPhone = util.isValidPhone(phoneNumber);
        this.setState({
          emailInvalid: !isValidEmail,
          phoneInvalid: !isValidPhone
        });
        if (!isValidEmail || !isValidPhone) {
          return;
        }
        this.setState({ submitted: true });
        //GA Tracking Account Creation
        if (window.dataLayer && window.dataLayer.push)
          window.dataLayer.push({ event: "Create_account" });
        // this.gtag_report_conversion_create_an_account();
        window.fbq("trackCustom", "RegisteredAfterOnboarding");
        //Removed CompleteRegistration 07/22/2019
        // window.fbq('track', 'CompleteRegistration');
        if (window.location)
          this.props.triggerNextStep({
            value:
              email +
              ":" +
              phoneNumber +
              ":" +
              password +
              ":" +
              this.state.accountOptIn.toString()+
              ":" +
              util.transformationCountryNumberId(this.state.phoneCountry)
          });
      }
    }
  }

  handleAccountOptIn = () => {
    this.setState({ accountOptIn: !this.state.accountOptIn });
  };

  renderErrorMessage() {
    if (
      this.state.emailInvalid ||
      this.state.phoneInvalid ||
      (this.props.authFailed &&
        this.props.error.statusCode === RESPONSE_STATUS.UNAUTHORIZED) ||
      this.state.errorMessage.length > 0
    )
      return (
        <div className="error-message">
          {this.state.emailInvalid && <p>Invalid email. Please try again.</p>}
          {this.state.phoneInvalid && (
            <p>Invalid phone number. Please try again.</p>
          )}
          {this.props.authFailed &&
            this.props.error.statusCode === RESPONSE_STATUS.UNAUTHORIZED && (
              <p>
                Your account already exists! Please enter the correct password
                to access your profile.
              </p>
            )}
          {this.state.errorMessage}
        </div>
      );
    return null;
  }

  render() {
    if (this.state.submitted) {
      return (
        <div
          style={
            this.props.answerWidthCheck <= 812
              ? answerBubbleStyleMobile
              : answerBubbleStyle
          }
        >
          Account information submitted.
        </div>
      );
    }
    const emailFilled = this.state.email ? "filled" : "";
    const phoneFilled = this.state.phoneNumber ? "filled" : "";
    const passwordFilled = this.state.password ? "filled" : "";
    const accountOptInFilled = this.state.accountOptIn ? "action" : "";
    return (
      <div className="onboarding-account-wrapper">
        {this.renderErrorMessage()}
        <QuestionComponent className="container question-component__inner right">
          <div className={"question__responses textbox focus " + emailFilled}>
            <input
              type="text"
              name="email"
              placeholder="Email"
              value={this.state.email}
              onChange={this.handleChange}
              autoComplete = "off"
              onBlur={
                window.location.pathname.includes("/ath")
                  ? this.handleEmailInputCompleteAth
                  : this.handleEmailInputComplete
              }
              onKeyPress={this.handleKeyPressed.bind(this)}
              onFocus={() => {
                this.setState({ errorMessage: "" });
              }}
            />
          </div>

          {
            // !this.state.accountExist &&
          }
          {
            /*!window.location.pathname.includes("/ath") &&*/
            <div className={"question__responses textbox focus " + phoneFilled} style={{display: 'flex',justifyContent: 'flex-start'}}>
              <div className="select-country-area">
                <div className="select-country-text">+{ util.getCountry(this.state.phoneCountry)} </div>
                <select className="select-country-phone" name="phoneCountry" onChange={this.handleChange}>
                  <option value="US">US (+1)</option>
                  <option value="Canada">Canada (+1)</option>
                  <option value="UK">UK (+44)</option>
                </select>
                <i className="fa fa-caret-down fa-lg select-country-array"></i>
              </div>
              <input
                className="phone-input"
                type="text"
                name="phoneNumber"
                placeholder="Phone"
                value={this.state.phoneNumber}
                onChange={this.handleChange}
                onKeyPress={this.handleKeyPressed.bind(this)}
                onKeyDown={this.handleKeyDown.bind(this)}
                style={{paddingLeft:'2px',width:'72%'}}
              />
            </div>
          }

          <div
            className={"question__responses textbox focus " + passwordFilled}
          >
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={this.state.password}
              onChange={this.handleChange}
              onKeyPress={this.handleKeyPressed.bind(this)}
            />
          </div>
          <QuestionComponentButton
            id="create-account-btn"
            type="button"
            className="ha-btn-circle disabled mr-1"
            autoComplete="new-password"
            onClick={this.handleSubmit.bind(this)}
          >
            <i
              id="create-account-icon"
              className="fa fa-chevron-right fa-align-center"
            />
          </QuestionComponentButton>
        </QuestionComponent>
        {(window.location.pathname.includes("/ath") ||
          window.location.pathname.includes("/hair/onboarding")) && (
          <div className="account-checkbox-messaging-container">
            <label className="account-checkbox-messaging-checkbox-container">
              <input
                name="accountOptIn"
                type="checkbox"
                checked={this.state.accountOptIn}
                onChange={this.handleAccountOptIn}
              />
              <span
                className={"account-checkbox-check " + accountOptInFilled}
              />
            </label>
            {window.location.pathname.includes("/ath") ? (
              <div className="account-checkbox-messaging">
                Keep me posted about exciting offers, products updates and more
                from All Things Hair. Learn more about our{" "}
                <a
                  className="account__privacy-policy-link"
                  target="_blank"
                  href="https://www.unilevernotices.com/usa/english/privacy-notice/notice.html"
                >
                  Privacy Notice
                </a>
                .
              </div>
            ) : (
              <div className="account-checkbox-messaging">
                Keep me posted about exciting offers, products updates and more
                from our partner All Things Hair, a Unilever website. Learn more
                about their{" "}
                <a
                  className="account__privacy-policy-link"
                  target="_blank"
                  href="https://www.unilevernotices.com/usa/english/privacy-notice/notice.html"
                >
                  Privacy Notice
                </a>
                .
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { helloava } = state;
  const { isFetching, isAuthenticated, authFailed, error } = helloava.auth;
  return { isFetching, isAuthenticated, authFailed, error };
}

function mapDispatchToProps(dispatch) {
  return {
    signIn: (email, password) => dispatch(signIn(email, password))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Account);



// WEBPACK FOOTER //
// ./src/views/onboarding/Account.js